import React, { useEffect, useState } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import BASE_URL from "../../components/link/link";
import "./TrackOrder.css";

const when = (iso) =>
  iso
    ? new Date(iso).toLocaleString("en-IN", { day: "numeric", month: "short", year: "numeric", hour: "numeric", minute: "2-digit" })
    : "";

const TrackOrder = () => {
  const { orderId } = useParams();
  const [track, setTrack] = useState(null);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/login");
      return;
    }

    const fetchTrack = async () => {
      try {
        const response = await fetch(`${BASE_URL}/shipment/track/${orderId}`, {
          headers: { authorization: `Bearer ${token}` },
        });
        if (response.status === 401) {
          localStorage.removeItem("token");
          navigate("/login");
          return;
        }
        const data = await response.json();
        if (!response.ok) throw new Error(data.message || "Could not load tracking.");
        setTrack(data);
      } catch (err) {
        setError(err.message || "Could not load tracking.");
      }
    };

    fetchTrack();
  }, [orderId, navigate]);

  return (
    <div className="track-order">
      <h1>Track Order</h1>
      {error ? (
        <div className="track-order-error">{error}</div>
      ) : !track ? (
        <div className="loading-message">Loading tracking details...</div>
      ) : (
        <>
          <div className="track-order-summary">
            <div>
              <small>DTDC AWB</small>
              <strong>{track.awb}</strong>
            </div>
            <div>
              <small>Status</small>
              <strong>{track.status}</strong>
            </div>
            {track.expectedDelivery && (
              <div>
                <small>Expected delivery</small>
                <strong>{new Date(track.expectedDelivery).toLocaleDateString("en-IN", { day: "numeric", month: "long", year: "numeric" })}</strong>
              </div>
            )}
          </div>
          <p className="track-order-items">{track.items.map((i) => `${i.name} (x${i.quantity})`).join(", ")}</p>

          {track.timeline.length === 0 ? (
            <p className="track-order-wait">Your parcel is booked. Updates appear here once DTDC picks it up.</p>
          ) : (
            <ul className="track-order-timeline">
              {track.timeline.map((t, i) => (
                <li key={i}>
                  <strong>{t.action}</strong>
                  {t.location && <span> - {t.location}</span>}
                  <small>
                    {when(t.at)}
                    {t.remarks && ` - ${t.remarks}`}
                  </small>
                </li>
              ))}
            </ul>
          )}
        </>
      )}
      <Link className="track-order-back" to="/my-orders">
        Back to my orders
      </Link>
    </div>
  );
};

export default TrackOrder;
